import type { ProfileVisibilitySettings, PublicProfileVisibilitySettings } from './types';

export const PUBLIC_JOURNEY_PREVIEW_LIMIT = 6;

export const DEFAULT_PROFILE_VISIBILITY: ProfileVisibilitySettings = {
  profile_enabled: true,
  show_erv_id: true,
  show_followers: true,
  show_following: true,
  show_location: true,
  show_member_since: true,
  show_stories: true,
  show_records: true,
  show_proof_cards: true,
  show_journey_preview: false,
  journey_map_visibility: 'private',
  show_family_preview: false,
  show_public_circles: true,
  allow_comments: true,
  allow_witness_requests: true,
  allow_circle_requests: true,
  featured_story_id: null,
  featured_record_id: null,
  allow_search_indexing: true,
  allow_vault_on_profile: true,
};

export const PUBLIC_PROFILE_VISIBILITY_SELECT =
  'profile_enabled,show_erv_id,show_followers,show_following,show_location,show_member_since,show_stories,show_records,show_proof_cards,show_journey_preview,journey_map_visibility,show_family_preview,show_public_circles,allow_comments,allow_witness_requests,allow_circle_requests,featured_story_id,featured_record_id,allow_search_indexing,allow_vault_on_profile';

export function mergeVisibility(
  row: Partial<ProfileVisibilitySettings> | null
): ProfileVisibilitySettings {
  return { ...DEFAULT_PROFILE_VISIBILITY, ...(row || {}) };
}

/** Remove curation IDs that visitors never need to receive. */
export function stripOwnerOnlyVisibility(
  visibility: ProfileVisibilitySettings
): PublicProfileVisibilitySettings {
  return {
    profile_enabled: visibility.profile_enabled,
    show_erv_id: visibility.show_erv_id,
    show_followers: visibility.show_followers,
    show_following: visibility.show_following,
    show_location: visibility.show_location,
    show_member_since: visibility.show_member_since,
    show_stories: visibility.show_stories,
    show_records: visibility.show_records,
    show_proof_cards: visibility.show_proof_cards,
    show_journey_preview: visibility.show_journey_preview,
    journey_map_visibility: visibility.journey_map_visibility,
    show_family_preview: visibility.show_family_preview,
    show_public_circles: visibility.show_public_circles,
    allow_comments: visibility.allow_comments,
    allow_witness_requests: visibility.allow_witness_requests,
    allow_circle_requests: visibility.allow_circle_requests,
    allow_search_indexing: visibility.allow_search_indexing,
    allow_vault_on_profile: visibility.allow_vault_on_profile,
  };
}
